import React, { useState, useEffect } from "react";
import {
  useGetAggregationByBuyerOfSellerQuery,
  useGetAggregationByBuyerQuery,
  useUploadBuyerDetailsMutation,
  useGetAddressInfoListQuery,
  useNegotiationCreatedMutation,
} from "./ProcurementApiSlice";
import { Card, CardBody, CardHeader, Spinner, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import Avatar from "@mui/material/Avatar";
import Skeleton from "react-loading-skeleton";
import Pages404 from "features/onboarding/users/farmer/Pages404";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import { TextField } from "@mui/material";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import QualityParamsModal from "./QualityParamsModal";
import InfoIcon from "@mui/icons-material/Info";
import { green } from "@mui/material/colors";
import { Modal as AntModal } from "antd";
import Autocomplete from "@mui/material/Autocomplete";
import AddIcon from "@mui/icons-material/Add";
import BuyerAddressAdd from "./BuyerAddressAdd";
import { Divider, Tag } from "antd";
export default function BuyCommodity({
  setActiveCard,
  UserData,
  activeCard,
  user_id,
}) {
  const RolesFromToken = useSelector(selectCurrentRoles);
  let created_by = RolesFromToken.organization_id;
  const {
    data: getAggregation,
    refetch,
  } = useGetAggregationByBuyerQuery(created_by, { refetchOnReconnect: true });
  const [showcolouredBorder, setColouredBorder] = useState("");
  const {
    data: getAddress,
    refetch: refetchAddress,
  } = useGetAddressInfoListQuery({ type: "buyer", UserData: UserData });
  const [cropUnit, setUnit] = useState("");
  const [qualityParams, setQualityParams] = useState("");
  const [createAggregation] = useUploadBuyerDetailsMutation();
  const [negotiationCreated] = useNegotiationCreatedMutation();
  const [cropId, setCropId] = useState("");
  const {
    data: getAggregationById,
    refetch: refetchSeller,
  } = useGetAggregationByBuyerOfSellerQuery(
    { cropId, created_by, cropUnit },
    { skip: !(cropId && created_by && cropUnit) }
  );
  const [AggregationList, setAggregationList] = useState([]);
  const [cropWiseAggregation, setcropWiseAggregation] = useState([]);
  const [widthShow, setWidth] = useState(false);
  const [loading, setloading] = useState(false);
  const [expanded, setExpanded] = useState("panel1");
  const [CropDataList, setCropList] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const [addStockData, setAddedStock] = useState({
    delivery_timeline: "",
    payment_timeline: "",
    address: "",
    payment_type: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [addressList, setaddressList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [negotiatioanValues, setNegotiationValue] = useState();
  const PaymentType = [
    { title: "D+", year: 1990 },
    { title: "Advance", year: 1991 },
    { title: "Loading", year: 1992 },
    { title: "D-Delivery", year: 1991 },
  ];
  const hideLeadModal = () => {
    setShowModal(false);
  };
  const handleClick = (item) => {
    setShowModal(true);
    setQualityParams(item);
  };

  useEffect(() => {
    if (getAggregation) {
      setAggregationList(getAggregation?.data);
      setShowLoading(false);
    }
    if (getAggregationById) {
      setcropWiseAggregation(getAggregationById?.data);
    }
  }, [getAggregation, getAggregationById, activeCard]);
  useEffect(() => {
    if (getAddress) setaddressList(getAddress?.data);
  }, [getAddress]);
  const handleRowSelectionModel = (item, index) => {
    setWidth(true);
    setCropId(item?.crop_code);
    setCropList(item);
    setColouredBorder(index);
    setUnit(item.unit_of_measure);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleClass = () => {
    if (widthShow) return "col-md-7 mt-2";
    else return "col-md-12 mt-2";
  };

  const handleSubmitOldSell = async (e, OlderSellerData) => {
    e.preventDefault();
    setloading(true);
    if (negotiatioanValues.quantity > OlderSellerData.quantity) {
      Swal.fire({
        title: `Quantity cannot be greater than Initial Quantity`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      });
      setloading(false);
      return;
    }
    if (negotiatioanValues.price > OlderSellerData.price) {
      Swal.fire({
        title: `Price cannot be greater than Initial Price`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      });
      setloading(false);
      return;
    }
    if (OlderSellerData.minimum_quantity !== 0) {
      if (negotiatioanValues.quantity < OlderSellerData.minimum_quantity) {
        Swal.fire({
          title: `Negotiation Quantity cannot be less then  Minimum Quantity`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        });
        setloading(false);

        return;
      }
    }

    try {
      const payload = {
        created_by: RolesFromToken.organization_id,
        StateName: selectedAddress.state,
        DistrictName: selectedAddress.city,
        BlockName: selectedAddress.address_line2,
        created_for: OlderSellerData.id,
        is_initial_relationship: true,
        entity_type: "Buyer",
        crop_code: OlderSellerData.crop_code,
        crop_name: OlderSellerData.crop_name,
        price: OlderSellerData.price,
        unit_of_measure: CropDataList.unit_of_measure,
        address: selectedAddress.address_line1,
        quantity: OlderSellerData.quantity,
        delivery_and_payment_detail: {
          delivery_timeline: addStockData.delivery_timeline,
          payment_timeline: addStockData.payment_timeline,
          payment_type: addStockData.payment_type,
        },
        pincode: selectedAddress.pincode,
        erp_address_reference: selectedAddress?.name,
        negotiation_price: parseInt(negotiatioanValues.price),
        negotiation_quantity: negotiatioanValues.quantity,
      };
      const data = await createAggregation(payload).unwrap();
      const payloadNegotiation = {
        price: parseInt(negotiatioanValues.price),
        quantity: negotiatioanValues.quantity,
        send_from: user_id,
        entity_type: "Buyer",
        procurement: data.data.id,
        send_to: data.data.created_for_id,
        send_from: data.data.created_by.user_id,
      };
      await negotiationCreated(payloadNegotiation).unwrap();
      Swal.fire({
        title: `${data.message}`,
        text: `Proceed to Ongoing Trade`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      }).then((result) => {
        if (result.isConfirmed) {
          setActiveCard("Buyer Cart");
        }
      });
      setloading(false);
      setAddedStock({
        delivery_timeline: "",
        payment_timeline: "",
      });
      setSelectedAddress("");
      refetchSeller();
    } catch (error) {
      toast.error(error?.data?.message || "An error occurred");
      setloading(false);
      setAddedStock({
        delivery_timeline: "",
        payment_timeline: "",
      });
      setSelectedAddress("");
    }
  };

  const handleChange2 = (name) => (e, value) => {
    if (name === "payment_type") {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else {
      setAddedStock({
        ...addStockData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleDynamicClass = (index) => {
    let className = "";
    switch (index % 3) {
      case 0:
        className = "bg-c-greenSample";
        break;
      case 1:
        className = "cardBlue";
        break;
      case 2:
        className = "bg-c-yellowSample";
        break;
      default:
        break;
    }
    return className;
  };
  const handleAddressAdd = () => {
    setIsModalOpen(true);
  };
  const handleDynamicClassText = (index) => {
    let className = "";
    switch (index % 3) {
      case 0:
        className = " bg-c-green-textColor cursor-pointer  ";
        break;
      case 1:
        className = " bg-c-blue-textColor cursor-pointer ";
        break;
      case 2:
        className = "bg-c-yellow-textColor cursor-pointer ";
        break;
      default:
        break;
    }
    return className;
  };
  const handleClassCol = () => {
    if (widthShow) return "col-lg-4";
    else return "col-lg-3";
  };
  const handlesetWidth = () => {
    setColouredBorder("");
    setWidth(false);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const [selectedAddress, setSelectedAddress] = useState("");
  const handleSelectedAddress = (event, newValue) => {
    setSelectedAddress(newValue);
  };
  const handleNegotiation = (e) => {
    setNegotiationValue({
      ...negotiatioanValues,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Card>
      <CardBody className="p-3">
        {showLoading ? (
          <Skeleton count={15} height="25px" />
        ) : AggregationList.length > 0 ? (
          <div className="row">
            <div className={handleClass()}>
              {/* <div class="row mt-2">
                {AggregationList?.map((item, index) => {
                  return (
                    <>
                      <div
                        className={handleClassCol()}
                        onClick={() => handleRowSelectionModel(item, index)}
                      >
                        <div
                          class="cardSample order-cardSample cursor-pointer"
                          style={{
                            border:
                              showcolouredBorder === index
                                ? "1px solid blue"
                                : "",
                            backgroundColor: "white",
                            boxShadow:
                              showcolouredBorder === item.id
                                ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
                                : "",
                          }}
                        >
                          <div class="card-blockSample ">
                            <div class="d-flex mt-2">
                              <Avatar
                                sx={{
                                  width: 24,
                                  height: 24,
                                  backgroundColor: "#fde3cf",
                                  color: "#f56a00",
                                  fontSize: 14,
                                }}
                              >
                                {item.crop_name.slice(0, 1)}
                              </Avatar>
                              <h6 className="mx-2">
                                &nbsp;<b>{item.crop_name}</b>
                              </h6>
                              <span
                                className="text-gray ml-auto mdi mdi-arrow-top-right bg-c-blue-textColor"
                                style={{ marginLeft: "auto" }}
                              ></span>
                            </div>
                            <div class="d-flex justify-content-between">
                              <Tooltip title="Quantity">
                                <ProductionQuantityLimitsIcon
                                  fontSize="small"
                                  className={handleDynamicClassText(index)}
                                />
                                <span className="mx-2 textGreyShade">
                                  {item.total_quantity}{" "}
                                  {item.unit_of_measure === "Metric Tonne"
                                    ? "MT"
                                    : item.unit_of_measure}
                                </span>
                              </Tooltip>
                              <span className={handleDynamicClass(index)}>
                                <CurrencyRupeeIcon
                                  fontSize="small"
                                  className=""
                                />
                                {item.total_price}
                              </span>
                            </div>
                            <div className="float-end f300">Price/Unit</div>
                            <h6 class="m-b-0 text-black f400">
                              Total Sellers : {item.sellers}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div> */}
              <div className="row mt-2">
                {AggregationList?.map((item, index) => {
                  const isNewItem = item.is_latest; // Check if it's a new item

                  return (
                    <div
                      className={handleClassCol()}
                      onClick={() => handleRowSelectionModel(item, index)}
                      key={index}
                    >
                      <div
                        className="cardSample order-cardSample cursor-pointer"
                        style={{
                          border:
                            showcolouredBorder === index
                              ? "2px solid blue"
                              : "",
                          backgroundColor: "white",
                          boxShadow:
                            showcolouredBorder === index
                              ? "rgba(0, 0, 0, 0.2) 0px 3px 8px"
                              : "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                          position: "relative",
                          transition: "all 0.3s ease-in-out",
                          marginBottom: "12px",
                          background: "#f9f9f9",
                        }}
                      >
                        {isNewItem && (
                          <div
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "10px",
                              backgroundColor: "red",
                              color: "white",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            New
                          </div>
                          //             <div
                          //   style={{
                          //     position: "absolute",
                          //     top: "4px",
                          //     right: "10px",
                          //     backgroundColor: "red",
                          //     color: "white",
                          //     padding: "4px 8px",
                          //     borderRadius: "50%",
                          //     fontSize: "12px",
                          //     fontWeight: "bold",
                          //     width: "20px",
                          //     height: "20px",
                          //     display: "flex",
                          //     alignItems: "center",
                          //     justifyContent: "center",
                          //   }}
                          // >
                          //   <span role="img" aria-label="new">✨</span>
                          // </div>
                        )}

                        <div className="card-blockSample">
                          <div className="d-flex align-items-center">
                            <img
                              src={item.media}
                              style={{
                                width: 40,
                                height: 40,
                                backgroundColor: "#ffecb3",
                                color: "#f39c12",
                                fontSize: 18,
                              }}
                            />

                            <h6 className="mx-2 text-gray">
                              <b>{item.crop_name}</b>
                            </h6>
                            <span
                              className="mdi mdi-arrow-top-right bg-c-blue-textColor"
                              style={{ marginLeft: "auto" }}
                            ></span>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <Tooltip title="Quantity">
                              <div className="d-flex align-items-center">
                                <ProductionQuantityLimitsIcon
                                  fontSize="small"
                                  className={handleDynamicClassText(index)}
                                />
                                <span className="mx-2 textGreyShade">
                                  {item.total_quantity}
                                  &nbsp;{item.unit_of_measure}
                                </span>
                              </div>
                            </Tooltip>

                            <div className={handleDynamicClass(index)}>
                              {item.sellers} Sellers
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {widthShow ? (
              <div className="col-lg-5">
                <Card>
                  <CardHeader
                    style={{ borderBottom: "1px solid #eddddd" }}
                    className="accordionColor"
                  >
                    <h5 className="">
                      &nbsp;&nbsp; <b></b> &nbsp; Seller Trade List &nbsp;
                      <i className="mdi mdi-account-details-outline text-primary"></i>
                      <span
                        className="badge badge-black float-end cursor-pointer mx-2 p-2"
                        onClick={() => handlesetWidth()}
                      >
                        <FontAwesomeIcon icon={faRotateLeft} />
                      </span>
                    </h5>
                  </CardHeader>
                  <CardBody style={{ padding: "10px" }}>
                    <div>
                      {cropWiseAggregation?.map((item, index) => {
                        const panel = `panel${index + 1}`;
                        const isExpanded = expanded === panel;
                        return (
                          <Accordion
                            key={index}
                            expanded={isExpanded}
                            onChange={handleChange(panel)}
                          >
                            <AccordionSummary
                              aria-controls={`${panel}d-content`}
                              id={`${panel}d-header`}
                              className="accordionColor"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <Typography variant="h5">
                                  {item.created_name}
                                </Typography>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails className="accordionBodyColor">
                              <div class="row mt-2">
                                <div class="col-md-4 col-xl-12">
                                  <div className="card p-3">
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <Avatar
                                          sx={{
                                            width: 40,
                                            height: 40,
                                            backgroundColor: "#fde3cf",
                                            color: "#f56a00",
                                          }}
                                        >
                                          {item.crop_name.slice(0, 2)}
                                        </Avatar>
                                      </div>
                                      <div className="col-lg-9">
                                        <h6>
                                          Commodity Name :
                                          <span className="steelblue">
                                            {" "}
                                            {item.crop_name}
                                          </span>
                                        </h6>
                                        <h6>
                                          Quality Parameters :
                                          <span
                                            onClick={(event) =>
                                              handleClick(
                                                item.quality_parameters
                                              )
                                            }
                                            className="cursor-pointer"
                                          >
                                            <span className="steelblue">
                                              {" "}
                                              View{" "}
                                              <InfoIcon className=" f300" />
                                            </span>
                                          </span>
                                        </h6>
                                      </div>
                                      <div className="d-flex justify-content-between mt-2">
                                        <h6>
                                          Quantity :
                                          <span className="steelblue">
                                            {item.quantity}
                                            &nbsp;
                                            {CropDataList?.unit_of_measure}
                                          </span>
                                        </h6>

                                        <h6>
                                          Total Price :
                                          <CurrencyRupeeIcon
                                            size="small"
                                            style={{ fontSize: "18px" }}
                                          />
                                          <span className="steelblue">
                                            {" "}
                                            {item.price * item.quantity}
                                          </span>
                                        </h6>

                                        <h6 class="">
                                          Price/Unit :{" "}
                                          <CurrencyRupeeIcon
                                            size="small"
                                            style={{ fontSize: "18px" }}
                                          />
                                          <span className="steelblue">
                                            {item.price}
                                          </span>
                                        </h6>
                                      </div>
                                      {item.minimum_quantity !== 0 ? (
                                        <h6>
                                          Minimum Lot Size :
                                          <span className="steelblue">
                                            {item.minimum_quantity}
                                            &nbsp;
                                            {CropDataList?.unit_of_measure}
                                          </span>
                                        </h6>
                                      ) : (
                                        ""
                                      )}
                                   
                                    </div>
                                  </div>
                                  {item?.has_expressed_interest ? (
                                    <div className="text-center">
                                      <Divider orientation="left">
                                        <Tag color="#87d068">
                                          Already Shown Interest
                                        </Tag>
                                      </Divider>
                                    </div>
                                  ) : (
                                    <div className="row">
                                      <form
                                        onSubmit={(e) =>
                                          handleSubmitOldSell(e, item)
                                        }
                                      >
                                        <h6 className="text-decoration-underline text-center">
                                          Delivery Location
                                        </h6>
                                        <div className="row">
                                          <div className="col-lg-8 MuiTextArea2">
                                            <Autocomplete
                                              id="address-autocomplete"
                                              className="mt-3 MuiTextArea"
                                              disableClearable
                                              options={addressList || []}
                                              getOptionLabel={(option) =>
                                                `${option.address_line1} ${option.city} ${option.state} ${option.pincode}`
                                              }
                                              onChange={handleSelectedAddress}
                                              name="Fulladdress"
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Select Address"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  required
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    type: "search",
                                                  }}
                                                />
                                              )}
                                            />
                                          </div>
                                          <Tooltip title="Add Address">
                                            <Avatar
                                              sx={{ bgcolor: green[700] }}
                                              className="mt-3 cursor-pointer mx-3"
                                            >
                                              <AddIcon
                                                onClick={handleAddressAdd}
                                              />
                                            </Avatar>
                                          </Tooltip>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-4 MuiTextArea2">
                                            <Tooltip
                                              title="Note: Delivery Timeline is : Date of Trade + Number of days entered by User"
                                              placement="top"
                                            >
                                              <TextField
                                                id="outlined-multiline-flexible"
                                                label="Delivery Time (Days)"
                                                name="delivery_timeline"
                                                onChange={handleChange2(
                                                  "delivery_timeline"
                                                )}
                                                value={
                                                  addStockData.delivery_timeline
                                                }
                                                required
                                                className="mt-3"
                                                multiline
                                                maxRows={2}
                                                style={{
                                                  width: "100%",
                                                  zIndex: 0,
                                                }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                              />
                                            </Tooltip>
                                          </div>
                                          <div className="col-lg-4  MuiTextArea2">
                                            <Autocomplete
                                              id="payment_type"
                                              name="payment_type"
                                              disableClearable
                                              value={addStockData.payment_type}
                                              className="mt-3"
                                              onChange={handleChange2(
                                                "payment_type"
                                              )}
                                              options={PaymentType?.map(
                                                (option) => option.title
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="payment Type"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  required
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    type: "search",
                                                  }}
                                                />
                                              )}
                                            />
                                          </div>
                                          {addStockData.payment_type ===
                                          "D+" ? (
                                            <div className="col-lg-4 MuiTextArea2">
                                              <Tooltip
                                                title="Note: Payment Timeline is : Date of Delivery + Number of days entered by User"
                                                placement="top"
                                              >
                                                <TextField
                                                  id="outlined-multiline-flexible"
                                                  label="Payment Time (Days)"
                                                  name="payment_timeline"
                                                  onChange={handleChange2(
                                                    "payment_timeline"
                                                  )}
                                                  value={
                                                    addStockData.payment_timeline
                                                  }
                                                  required
                                                  className="mt-3"
                                                  multiline
                                                  maxRows={2}
                                                  style={{
                                                    width: "100%",
                                                    zIndex: 0,
                                                  }}
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Tooltip>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <h6 className="text-decoration-underline text-center mt-2 mb-2">
                                            Negotiation Details
                                          </h6>

                                          <div className="d-flex align-items-center">
                                            <div className="flex-grow-1 MuiTextArea2 col-lg-4">
                                              <Tooltip
                                                title="Note: Enter the Negotiation Price"
                                                placement="top"
                                              >
                                                <TextField
                                                  id="outlined-multiline-flexible"
                                                  label="Negotiation Price/ Unit"
                                                  name="price"
                                                  onChange={handleNegotiation}
                                                  className="mt-3"
                                                  multiline
                                                  required
                                                  maxRows={2}
                                                  onKeyPress={(event) => {
                                                    if (!/\d/.test(event.key)) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  fullWidth
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Tooltip>
                                            </div>
                                            <div className="flex-grow-1 MuiTextArea2 col-lg-4">
                                              <Tooltip
                                                title="Note: Enter the Negotiation Quantity"
                                                placement="top"
                                              >
                                                <TextField
                                                  id="outlined-multiline-flexible"
                                                  label="Negotiation Quantity"
                                                  name="quantity"
                                                  onChange={handleNegotiation}
                                                  className="mt-3 mx-2"
                                                  multiline
                                                  required
                                                  onKeyPress={(event) => {
                                                    if (!/\d/.test(event.key)) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  maxRows={2}
                                                  fullWidth
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                />
                                              </Tooltip>
                                            </div>
                                            <div className="ms-3">
                                              <Button
                                                variant="contained"
                                                className="text-center mt-1"
                                                color="success"
                                                size="small"
                                                type="submit"
                                              >
                                                BID &nbsp;
                                                {loading ? (
                                                  <Spinner size="sm" />
                                                ) : (
                                                  ""
                                                )}
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </div>

                    <Modal show={showModal} onHide={hideLeadModal} size="xl">
                      <Modal.Header closeButton>
                        <Modal.Title style={{ color: "" }} className="fw-bold">
                          Quality Parameters
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ padding: "2%" }}>
                        <QualityParamsModal qualityParams={qualityParams} />
                      </Modal.Body>
                    </Modal>
                    <AntModal
                      title="Add Address"
                      open={isModalOpen}
                      onCancel={handleClose}
                      footer={null}
                    >
                      <BuyerAddressAdd
                        handleChange={handleChange2}
                        addStockData={addStockData}
                        UserData={UserData}
                        refetchAddress={refetchAddress}
                        setIsModalOpen={setIsModalOpen}
                        handleClose={handleClose}
                      />
                    </AntModal>
                  </CardBody>
                </Card>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <Pages404 />
        )}
      </CardBody>
    </Card>
  );
}
